'use client';

import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

export const BuyAgainHeading = () => {
  const t = useTranslations();

  return (
    <div
      className="d-flex align-items-center px-0 pt-0 py-2 p-blg-3"
      data-testid="buy-again"
    >
      <CatHeading variant="title-sm">{t('HOMEPAGE_BUY_AGAIN')}</CatHeading>
    </div>
  );
};
